
import { ApiFactory } from '@/api/api-factory';

// Re-export types from the storage API client implementation
export type { StorageConfig } from '@/api/supabase/storage-api-client';

/**
 * Set the active storage configuration
 */
export const setStorageConfig = (config: any) => {
  return ApiFactory.getStorageClient().setStorageConfig(config);
};

/**
 * Get the active storage configuration
 */
export const getStorageConfig = () => {
  return ApiFactory.getStorageClient().getStorageConfig();
};

/**
 * Get the current bucket name from configuration
 */
export const getCurrentBucketName = (): string => {
  return ApiFactory.getStorageClient().getStorageConfig().bucketName;
};

/**
 * Upload a file to storage
 * @param file The file to upload
 * @param path The path where the file should be stored
 * @returns Promise with the URL of the uploaded file
 */
export const uploadFile = async (file: File, path: string): Promise<string> => {
  return ApiFactory.getStorageClient().uploadFile(file, path);
};

/**
 * Delete a file from storage
 * @param path The path of the file to delete
 */
export const deleteFile = async (path: string): Promise<void> => {
  return ApiFactory.getStorageClient().deleteFile(path);
};

/**
 * Get a public URL for a file
 * @param path The path of the file
 * @param fallbackUrl Optional fallback URL if the file doesn't exist
 * @returns Promise with the public URL
 */
export const getFileUrl = async (path: string, fallbackUrl?: string): Promise<string> => {
  return ApiFactory.getStorageClient().getFileUrl(path, fallbackUrl);
};
